import { Inject, InjectionToken } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { merge } from 'lodash-es';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

export const APP_NAME_TOKEN = new InjectionToken<AppName>('AppName');

export class CustomTranslateLoader implements TranslateLoader {
    private app: App = { name: 'mediahaven2', group: 'mediahaven' };

    constructor(@Inject(APP_NAME_TOKEN) private appName: AppName) {
        if (this.appName) {
            this.app = this.getApp(this.appName);
        }
    }

    getTranslation(lang: string): Observable<any> {
        return from(
            Promise.all([
                import(`../translations/shared/stylehaven/${lang}.ts`),
                import(`../translations/shared/${this.app.group}/${lang}.ts`),
                import(`../translations/app-specific/${this.app.name}/${lang}.ts`)
            ])
        ).pipe(
            map(([styleHavenTranslations, sharedTranslations, appSpecificTranslations]) => {
                // App specific translation keys will override shared translation keys
                const merged = merge(
                    styleHavenTranslations.default,
                    sharedTranslations.default,
                    appSpecificTranslations.default
                );
                return merged;
            })
        );
    }

    private getApp(appName: AppName): App {
        if (mediahavenApps.includes(appName as any)) {
            return { name: appName, group: 'mediahaven' };
        } else {
            return { name: 'mediahaven2', group: 'mediahaven' }; // default fallback
        }
    }
}

export type AppName = MediahavenApp;

interface App {
    name: AppName;
    group: 'mediahaven';
}

type MediahavenApp = (typeof mediahavenApps)[number];

const mediahavenApps = ['mediahaven2', 'portal', 'management'] as const;
